import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";

import { getBlogPage } from "../../model/blog";
import { commonErr } from "../common/errors";
import Header from "../components/header";
import Footer from "../components/footer";
import { MessagePage } from "../common/messagebox";
import { LoadingPage } from "../common/loading";
import { formatTitleInUrl } from "../common/common";

// import defThumb1 from "../../static/images/homev2/blog-1.jpg";
import { IcBlogNext, IcBlogPrev } from "../common/svg";

export default class Articles extends React.Component {
	constructor() {
		super();

		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
		};
	}

	componentDidMount() {
		getBlogPage(0).then((resp) => {
			this.setState({
				err: resp.data.error,
				errMsg: resp.data.errorMessage,
				blogs: resp.data.data,
			});
		});
	}

	next = () => {
		window.scrollTo(0, 0);
		getBlogPage(this.state.blogs.curPage + 1).then((resp) => {
			this.setState({
				err: resp.data.error,
				errMsg: resp.data.errorMessage,
				blogs: resp.data.data,
			});
		});
	};

	pre = () => {
		if (this.state.blogs.curPage > 0) {
			window.scrollTo(0, 0);
			getBlogPage(this.state.blogs.curPage - 1).then((resp) => {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
					blogs: resp.data.data,
				});
			});
		}
	};

	go = (page) => {
		window.scrollTo(0, 0);
		getBlogPage(page.number).then((resp) => {
			this.setState({
				err: resp.data.error,
				errMsg: resp.data.errorMessage,
				blogs: resp.data.data,
			});
		});
	};

	render() {
		var content;
		if (this.state.err === commonErr.INNIT || this.state.err === commonErr.LOADING) {
			content = <LoadingPage />;
		} else if (this.state.blogs && this.state.blogs.blogs) {
			const blogs = this.state.blogs.blogs;
			const curPage = this.state.blogs.curPage;
			const maxPage = this.state.blogs.totalPages;
			const pagination = [];
			for (var i = 0; i < maxPage; ++i) {
				const page = { number: i };
				pagination.push(
					<p key={i} className={`number ${curPage === i ? "active" : ""}`} onClick={() => this.go(page)}>
						{i + 1}
					</p>
				);
			}

			content = (
				<div className="blog-main">
					<div className="blog-main-title">
						<h2>MIOTO Blog</h2>
					</div>
					<div className="blog-place">
						<div className="blog-place-main">
							<div className="blog-inner">
								<Link to={`/blog/${formatTitleInUrl(blogs[0].title)}/${blogs[0].id}`}>
									<img loading="lazy" src={blogs[0].thumb ? blogs[0].thumb : undefined} alt="" />
								</Link>
							</div>
							<div className="group-tag">
								<span className="info info-bg">Trải nghiệm</span>
								<Link to={`/blog/${formatTitleInUrl(blogs[0].title)}/${blogs[0].id}`}>
									<h5>{blogs[0].title}</h5>
								</Link>
							</div>
							<p>{blogs[0].desc}</p>
						</div>
						<div className="blog-place-other">
							{blogs.map(
								(blog, i) =>
									i > 0 &&
									i < 4 && (
										<Link
											className="blog-other-item"
											key={blog.id}
											to={`/blog/${formatTitleInUrl(blog.title)}/${blog.id}`}>
											<img loading="lazy" src={blog.thumb ? blog.thumb : undefined} alt="" />
											<div className="content">
												<div className="group-tag">
													<span className="info info-bg">Trải nghiệm</span>
												</div>
												<h6>{blog.title}</h6>
												<p className="disc">{blog.desc}</p>
											</div>
										</Link>
									)
							)}
						</div>
					</div>
					<div className="blog-content">
						<div className="blog-content-inner col3-mg20">
							{blogs.map((blog) => (
								<Link className="item" to={`/blog/${formatTitleInUrl(blog.title)}/${blog.id}`} key={blog.id}>
									<div className="fix-img">
										<img loading="lazy" src={blog.thumb ? blog.thumb : undefined} alt="" />
									</div>
									<h5>{blog.title}</h5>
									<p className="disc">{blog.desc}</p>
								</Link>
							))}
						</div>
					</div>

					<div className="page-numbers">
						<div className="wrap-svg" onClick={this.pre}>
							<IcBlogPrev />
						</div>
						{pagination}
						<div className="wrap-svg">
							<IcBlogNext onClick={this.next} />
						</div>
					</div>
				</div>
			);
		} else {
			content = <MessagePage message={"Không tìm thấy nội dung."} />;
		}

		return (
			<div className="mioto-layout">
				<Header />
				<section className="body">
					<div className="blog">
						<div className="m-container">{content}</div>
					</div>
				</section>
				<Footer />
			</div>
		);
	}
}
